/* Naguirre — alerta de combo na página das blusas (assets/naguirre-combo.js · rascunho C · 04/10/2026).

   O QUE FAZ: mantém o cartão do snippets/ng-pdp-combo.liquid em dia com o carrinho (quantas peças do
   combo já estão lá, quantas faltam, quanto ela economiza) e comemora quando um combo fecha.
   A regra de cada combo e todos os textos vêm do próprio snippet (<script data-ng-combo-config>);
   aqui não há preço, desconto nem frase fixos.

   DE ONDE VEM O NÚMERO (nada é escrito no carrinho; nenhum rastreio novo):
   1) ao abrir a página: o Liquid já desenhou o estado certo (carrinho da sessão, sem rede);
   2) evento "cart-update" do tema (adicionar, +, −, lixeira, cupom, editar, compra rápida): o
      detail é o carrinho inteiro, com product_id em cada item;
   3) reserva, quando o evento não traz o carrinho inteiro (apps de brinde), ao voltar pelo cache do
      navegador, ao voltar à aba e quando o toque em "Adicionar" não gera evento em 3,5 s:
      window.NaguirreFrete.lerCarrinho(), que lê o /cart.js por um Web Worker (o fetch da página,
      que o Web Pixels e os apps de cupom/brinde embrulham, não é usado). As linhas dele trazem a
      variante; o produto sai do mapa de variantes que o snippet imprime (ou do campo "produto",
      se um dia o naguirre-frete.js passar a mandá-lo).
   NUNCA: /cart/add.js, /cart/change.js, /cart/update.js, Shopify.getCart, $.getJSON('/cart.js'),
   fetch('/cart.js') da página nem window.updateCart() (abre a gaveta).
   Se não der para ler com certeza, o cartão volta à oferta pura ("A cada 3 peças, você economiza
   R$ 19,80"), que é sempre verdadeira; nunca mostra um número que não confirmou.

   GAVETA: o "Adicionar" abre a gaveta do carrinho por cima da página. Enquanto ela está aberta, o
   cartão guarda a mudança e só a mostra quando a gaveta fecha (classe cart-sidebar-show do <body>),
   para ela ver a bolinha sendo carimbada. O leitor de tela recebe o aviso na hora.
   COMEMORAÇÃO: quando o número de combos completos SOBE por uma ação dela nesta página; com o cartão
   à vista (se não estiver, quando ela rolar até ele); uma vez por grupo e por número de combos na
   sessão; sem movimento se o aparelho pede menos movimento. Nunca ao abrir a página. */
(function (raiz) {
  'use strict';
  if (raiz.NaguirreCombo) return;

  var ESPERA_GAVETA = 450;     // a gaveta e o fundo escuro do tema saem em ~500 ms
  var DURACAO_FESTA = 2000;
  var ESPERA_CLIQUE = 3500;    // sem "cart-update" depois do toque em "Adicionar": relê
  var ESPERA_PARCIAL = 600;    // evento sem o carrinho inteiro: relê, se nenhum inteiro chegar antes

  // ---------------------------------------------------------------------------------------------
  // Núcleo (sem DOM; também roda no Node para os testes)
  // ---------------------------------------------------------------------------------------------

  // Centavos -> "R$ 129,90", no formato de dinheiro da loja (shop.money_format, vindo do snippet).
  function dinheiro(centavos, formato) {
    var c = Math.round(Number(centavos) || 0);
    function num(casas, mil, dec) {
      var s = (c / 100).toFixed(casas).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (casas ? dec + s[1] : '');
    }
    var f = String(formato || 'R$ {{amount_with_comma_separator}}');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, '\'', '.');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(2, ' ', '.');
        default: return num(2, '.', ',');            // amount_with_comma_separator (a da loja)
      }
    }).replace(/<[^>]*>/g, '');
  }

  // ["1 Kyoto", "1 Donna"] -> "1 Kyoto e 1 Donna"; três ou mais -> "a, b e c"
  function lista(partes) {
    if (partes.length < 2) return partes.join('');
    return partes.slice(0, -1).join(', ') + ' e ' + partes[partes.length - 1];
  }

  function preencher(molde, v) {
    return String(molde == null ? '' : molde).replace(/\{(\w+)\}/g, function (m, k) {
      return v[k] != null ? String(v[k]) : m;
    });
  }

  // HTML dos moldes -> texto corrido para o leitor de tela.
  function semMarcacao(html) {
    return String(html || '')
      .replace(/<\/span>\s*<span/g, '</span>. <span')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ').trim();
  }
  function comPonto(t) { return t && !/[.!?]$/.test(t) ? t + '.' : t; }

  // Brinde automático (Dr Free Gift): "Gift ID" nas propriedades, ou linha de preço zero.
  function ehBrinde(i) {
    var p = (i && i.properties) || {};
    if (p['Gift ID'] || p['Gift ID ']) return true;
    return i.original_line_price === 0 && i.final_line_price === 0;
  }

  function mapaVariantes(cfg) {
    if (cfg._mapa) return cfg._mapa;
    var m = {};
    (cfg.modelos || []).forEach(function (mo) {
      (mo.v || []).forEach(function (v) { m[String(v)] = String(mo.id); });
    });
    cfg._mapa = m;
    return m;
  }

  /* Peças do grupo por blusa: { "<product_id>": quantidade }.
     itens: os do carrinho (detail do "cart-update": product_id, variant_id, quantity, properties)
     ou as linhas do NaguirreFrete.lerCarrinho() ({ id: variante, quantidade[, produto] }).
     Soma por produto, nunca por linha (a Shopify quebra 3 Carolina em 2 + 1). Devolve null quando
     uma linha não dá para atribuir com certeza (mapa de variantes incompleto). */
  function contar(cfg, itens) {
    var por = {}, doGrupo = {}, mapa = mapaVariantes(cfg);
    (cfg.modelos || []).forEach(function (mo) { doGrupo[String(mo.id)] = true; por[String(mo.id)] = 0; });
    for (var x = 0; x < itens.length; x++) {
      var i = itens[x];
      if (!i || typeof i !== 'object' || ehBrinde(i)) continue;
      var q = parseInt(i.quantity != null ? i.quantity : i.quantidade, 10);
      if (!(q > 0)) continue;
      var pid = i.product_id != null ? i.product_id : i.produto;
      if (pid == null) {
        var vid = i.variant_id != null ? i.variant_id : i.id;
        pid = vid != null ? mapa[String(vid)] : null;
        if (pid == null) {
          if (cfg.mapa_completo === false) return null;   // pode ser uma blusa do grupo fora do mapa
          continue;                                       // outra peça da loja: não conta
        }
      }
      pid = String(pid);
      if (doGrupo[pid]) por[pid] += q;
    }
    return por;
  }

  /* Estado do cartão. fase: convite (0 peça) | progresso (falta peça; com k >= 1 é "rumo ao próximo
     combo") | garantido (múltiplo exato) | oferta (sem leitura confiável). k = combos completos. */
  function estado(cfg, por) {
    var N = cfg.combo_qtd, n = 0, outros = 0, atual = String(cfg.produto);
    Object.keys(por || {}).forEach(function (pid) {
      var q = por[pid] || 0;
      n += q;
      if (pid !== atual) outros += q;
    });
    var k = Math.floor(n / N), resto = n % N;
    var fase = cfg.so_oferta ? 'oferta' : (n === 0 ? 'convite' : (resto === 0 ? 'garantido' : 'progresso'));
    return { fase: fase, N: N, n: n, k: k, resto: resto, falta: resto ? N - resto : 0, outros: outros, por: por || {} };
  }
  function estadoOferta(cfg) {
    return { fase: 'oferta', N: cfg.combo_qtd, n: 0, k: 0, resto: 0, falta: 0, outros: 0, por: {} };
  }
  function mesmoEstado(a, b) {
    if (!a || !b || a.fase !== b.fase || a.n !== b.n) return false;
    var chaves = Object.keys(a.por).concat(Object.keys(b.por));
    for (var i = 0; i < chaves.length; i++) if ((a.por[chaves[i]] || 0) !== (b.por[chaves[i]] || 0)) return false;
    return true;
  }

  // Textos e marcas de um estado, a partir dos moldes do snippet.
  function textos(cfg, e) {
    var T = cfg.textos || {}, N = e.N;
    var noCarrinho = [];
    (cfg.modelos || []).forEach(function (mo) {
      var q = e.por[String(mo.id)] || 0;
      if (q > 0) noCarrinho.push('<strong>' + q + ' ' + mo.nome + '</strong>');
    });
    var r = { fase: e.fase, icone: 'etiqueta', classes: ['is-' + e.fase], cheias: 0, proxima: -1, conta: '' };
    if (e.fase === 'progresso' && e.falta === 1) r.classes.push('is-quase');
    if (e.k > 0 && e.fase !== 'oferta') r.classes.push('tem-combo');

    if (e.fase === 'garantido') {
      r.icone = 'ok';
      r.selo = e.k === 1 ? T.selo_garantido : T.selo_garantidos;
      r.frase = T.frase_garantido;
      r.nota = T.nota_garantido;
      r.rotulo = T.rotulo_garantido;
      r.cheias = N;
      if (e.k === 1) r.conta = T.conta;
    } else if (e.fase === 'progresso') {
      r.cheias = e.resto;
      r.proxima = e.resto;
      r.conta = T.conta;
      if (e.k > 0) {
        r.icone = 'ok';
        r.selo = e.k === 1 ? T.selo_acima : T.selo_acimas;
        r.rotulo = T.rotulo_proximo;
        r.frase = e.falta === 1 ? T.frase_acima_quase : T.frase_acima;
      } else {
        r.selo = T.selo_oferta;
        r.rotulo = T.rotulo;
        r.frase = e.falta === 1 ? T.frase_quase : T.frase_progresso;
      }
      r.nota = e.outros > 0 && (cfg.modelos || []).length > 1 ? T.nota_carrinho : T.nota_mistura;
    } else if (e.fase === 'convite') {
      r.selo = T.selo_oferta;
      r.frase = T.frase_convite;
      r.nota = T.nota_mistura;
      r.rotulo = T.rotulo;
      r.proxima = 0;
    } else {                                              // oferta
      r.selo = T.selo_oferta;
      r.frase = T.frase_oferta;
      r.nota = T.nota_mistura;
      r.rotulo = '';
    }

    var v = {
      k: e.k, n: e.n, falta: e.falta, cheias: r.cheias,
      total: cfg.combo_preco != null ? dinheiro(cfg.combo_preco * e.k, cfg.moeda) : '',
      economia_total: dinheiro(cfg.desconto * e.k, cfg.moeda),
      lista: lista(noCarrinho)
    };
    r.selo = preencher(r.selo, v);
    r.frase = preencher(r.frase, v);
    r.nota = preencher(r.nota, v);
    r.conta = preencher(r.conta, v);
    r.rotulo = preencher(r.rotulo, v);

    // O que o leitor de tela ouve quando o carrinho muda por ação dela.
    var frase = semMarcacao(r.frase), selo = semMarcacao(r.selo);
    if (e.fase === 'garantido') r.anuncio = selo + ' ' + comPonto(frase);
    else if (e.fase === 'progresso' && e.k > 0) r.anuncio = comPonto(selo) + ' ' + comPonto(r.rotulo) + ' ' + comPonto(frase);
    else if (e.fase === 'progresso') r.anuncio = comPonto(r.rotulo) + ' ' + comPonto(frase);
    else if (e.fase === 'convite') r.anuncio = comPonto(frase);
    else r.anuncio = '';
    return r;
  }

  var nucleo = {
    dinheiro: dinheiro, lista: lista, preencher: preencher, semMarcacao: semMarcacao, contar: contar,
    estado: estado, estadoOferta: estadoOferta, mesmoEstado: mesmoEstado, textos: textos
  };
  if (typeof document === 'undefined') {                  // Node (testes): só o núcleo
    if (typeof module === 'object' && module.exports) module.exports = nucleo;
    return;
  }

  // ---------------------------------------------------------------------------------------------
  // Página
  // ---------------------------------------------------------------------------------------------
  var cartoes = [];
  var interagiu = false;       // só anuncia e comemora depois de um toque/tecla dela nesta página
  var ultimoEvento = 0;        // hora do último "cart-update" com o carrinho inteiro
  var leitura = { versao: 0, espera: 0, ultima: 0 };
  var esperaClique = 0;
  var esperaGaveta = 0;
  var gavetaEstava = null;
  var escondidaEm = 0;

  function gavetaAberta() {
    return document.body.classList.contains('cart-sidebar-show') ||
      document.documentElement.classList.contains('ng-gaveta-aberta');
  }
  function poucoMovimento() {
    try { return !!(raiz.matchMedia && raiz.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function visivel(el) {
    var r = el.getBoundingClientRect();
    var h = raiz.innerHeight || document.documentElement.clientHeight;
    if (!r.height) return false;
    return Math.min(r.bottom, h) - Math.max(r.top, 0) >= r.height * 0.6;
  }
  function chave(card, k) { return 'ngCombo:' + (card.cfg.grupo || '') + ':' + k; }
  function jaComemorou(card, k) { try { return sessionStorage.getItem(chave(card, k)) === '1'; } catch (e) { return false; } }
  function marcarComemorado(card, k) { try { sessionStorage.setItem(chave(card, k), '1'); } catch (e) { /* sem armazenamento: tudo bem */ } }

  // Escreve um estado no cartão (as mesmas classes, textos e atributos que o Liquid imprime).
  function desenhar(card, e) {
    var el = card.el, r = textos(card.cfg, e);
    ['is-convite', 'is-progresso', 'is-garantido', 'is-oferta', 'is-quase', 'tem-combo'].forEach(function (c) { el.classList.remove(c); });
    r.classes.forEach(function (c) { el.classList.add(c); });
    el.setAttribute('data-estado', e.fase);
    el.setAttribute('data-n', String(e.n));
    var selo = el.querySelector('[data-ngc-selo]');
    if (selo) selo.setAttribute('data-icone', r.icone);
    var no;
    if ((no = el.querySelector('[data-ngc-selo-texto]'))) no.innerHTML = r.selo;
    if ((no = el.querySelector('[data-ngc-frase]'))) no.innerHTML = r.frase;
    if ((no = el.querySelector('[data-ngc-nota]'))) no.innerHTML = r.nota;
    if ((no = el.querySelector('[data-ngc-conta]'))) no.textContent = r.conta;
    if ((no = el.querySelector('[data-ngc-cartela]'))) {
      if (r.rotulo) no.setAttribute('aria-label', r.rotulo); else no.removeAttribute('aria-label');
    }
    var pecas = el.querySelectorAll('[data-ngc-peca]');
    for (var i = 0; i < pecas.length; i++) {
      pecas[i].classList.toggle('is-cheia', i < r.cheias);
      pecas[i].classList.toggle('is-proxima', i === r.proxima);
    }
    return r;
  }

  function anunciar(card, texto) {
    var a = card.el.querySelector('[data-ngc-aviso]');
    if (!a || !texto) return;
    clearTimeout(card.tAviso);
    a.textContent = '';                                   // limpa e escreve: lido mesmo se repetir
    card.tAviso = setTimeout(function () { a.textContent = texto; }, 100);
  }

  function semCarimbo(card) {
    clearTimeout(card.tCarimbo);
    var pecas = card.el.querySelectorAll('[data-ngc-peca]');
    for (var j = 0; j < pecas.length; j++) pecas[j].classList.remove('is-carimbo');
    return pecas;
  }

  /* As bolinhas das peças que acabaram de entrar "carimbam" (peça nova sem comemoração).
     As bolinhas mostram o combo da vez: em "progresso", as peças depois dos combos já fechados;
     em "garantido", o último combo fechado. Tirar peça não carimba nada. */
  function carimbar(card, antes, e) {
    var pecas = semCarimbo(card);
    if (antes.fase === 'oferta' || e.n <= antes.n || (e.fase !== 'progresso' && e.fase !== 'garantido')) return;
    var inicio = (e.fase === 'garantido' ? e.k - 1 : e.k) * e.N;  // nº de peças antes da 1ª bolinha
    var desde = Math.max(antes.n - inicio, 0), ate = Math.min(e.n - inicio, pecas.length);
    if (desde >= ate) return;
    void card.el.offsetWidth;                             // reinicia a animação
    for (var i = desde, ordem = 0; i < ate; i++, ordem++) {
      pecas[i].style.setProperty('--ngc-atraso', (ordem * 0.12) + 's');
      pecas[i].classList.add('is-carimbo');
    }
    card.tCarimbo = setTimeout(function () { semCarimbo(card); }, 1300);
  }

  // Liga a comemoração. Chamado ANTES de desenhar o estado novo, para a cor das bolinhas mudar em onda
  // (o atraso de cada uma só vale se .is-festa entrar no mesmo quadro que .is-garantido).
  function festejar(card) {
    var el = card.el;
    semCarimbo(card);
    if (el.classList.contains('is-festa')) { el.classList.remove('is-festa'); void el.offsetWidth; }
    el.classList.add('is-festa');
    clearTimeout(card.tFesta);
    card.tFesta = setTimeout(function () { el.classList.remove('is-festa'); }, DURACAO_FESTA);
  }

  // Comemoração para quando o cartão aparecer na tela (ela rolou para longe antes de fechar a gaveta).
  function festaQuandoVisivel(card, k) {
    card.festaPendente = k;
    if (card.observador) return;
    if (typeof IntersectionObserver !== 'function') { card.festaPendente = 0; marcarComemorado(card, k); return; }
    card.observador = new IntersectionObserver(function (entradas) {
      var ok = entradas.some(function (x) { return x.isIntersecting && x.intersectionRatio >= 0.6; });
      if (!ok || gavetaAberta() || document.hidden) return;
      card.observador.disconnect();
      card.observador = null;
      var alvo = card.festaPendente;
      card.festaPendente = 0;
      if (alvo && card.mostrado.fase !== 'oferta' && card.mostrado.k === alvo && !jaComemorou(card, alvo)) {
        marcarComemorado(card, alvo);
        if (!poucoMovimento()) festejar(card);
      }
    }, { threshold: [0.6] });
    card.observador.observe(card.el);
  }

  /* Chegou um estado novo para o cartão. origem: 'evento' (cart-update inteiro), 'clique' (releitura
     depois do toque em "Adicionar"), 'parcial' (releitura depois de um evento incompleto) ou 'volta'
     (cache do navegador / volta à aba: atualiza calado, sem comemorar). */
  function receber(card, e, origem) {
    if (mesmoEstado(card.alvo || card.mostrado, e)) return;  // o tema às vezes manda o mesmo carrinho 2x
    var ativo = interagiu && origem !== 'volta';
    if (ativo && e.fase !== 'oferta') anunciar(card, textos(card.cfg, e).anuncio);
    card.alvo = e;
    card.ativo = card.ativo || ativo;
    if (gavetaAberta() || document.hidden) return;          // mostra quando a gaveta fechar / a aba voltar
    mostrar(card);
  }

  function mostrar(card) {
    var e = card.alvo;
    if (!e) return;
    var ativo = card.ativo;
    card.alvo = null;
    card.ativo = false;
    var antes = card.mostrado, base = card.base;
    var festa = ativo && e.fase !== 'oferta' && e.k > base.k && !jaComemorou(card, e.k);
    var animar = ativo && !poucoMovimento();
    var aVista = animar && visivel(card.el);
    if (festa && (aVista || !animar)) marcarComemorado(card, e.k);
    if (festa && aVista) festejar(card);                    // mesmo quadro do estado novo (onda de cor)

    desenhar(card, e);
    card.mostrado = e;
    if (e.fase !== 'oferta') card.base = e;
    if (e.k < base.k || e.fase === 'oferta') card.festaPendente = 0;

    if (!animar) return;
    if (aVista) { if (!festa) carimbar(card, antes, e); }
    else if (festa) festaQuandoVisivel(card, e.k);           // comemora quando ela rolar até o cartão
  }

  function mostrarGuardados() {
    if (gavetaAberta() || document.hidden) return;
    cartoes.forEach(function (card) { if (card.alvo) mostrar(card); });
  }

  function iniciar() {
    cartoes = cartoes.filter(function (c) { return document.documentElement.contains(c.el); });
    var els = document.querySelectorAll('[data-ng-combo]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('data-ng-combo-pronto')) continue;
      var cfg = null;
      try {
        var no = el.querySelector('script[data-ng-combo-config]');
        cfg = JSON.parse(no ? no.textContent : 'null');
      } catch (err) { cfg = null; }
      if (!cfg || !(cfg.combo_qtd >= 2) || !cfg.textos || !Array.isArray(cfg.modelos)) continue;
      el.setAttribute('data-ng-combo-pronto', '');
      var e = estado(cfg, cfg.inicial || {});              // o que o Liquid já desenhou: sem aviso, sem festa
      cartoes.push({ el: el, cfg: cfg, mostrado: e, base: e, alvo: null, ativo: false, festaPendente: 0 });
    }
  }

  // Reserva: lê o carrinho pelo Worker do naguirre-frete.js (carregado depois deste, por isso só aqui).
  function reler(origem) {
    clearTimeout(leitura.espera);
    leitura.espera = setTimeout(function () {
      var minha = ++leitura.versao;
      if (!cartoes.length) return;
      var F = raiz.NaguirreFrete;
      if (!F || typeof F.lerCarrinho !== 'function') { emOferta(origem); return; }
      leitura.ultima = Date.now();
      F.lerCarrinho().then(function (r) {
        if (minha !== leitura.versao) return;               // um evento mais novo já chegou
        if (!r || !Array.isArray(r.linhas)) throw new Error('resposta sem linhas');
        cartoes.forEach(function (card) {
          var por = contar(card.cfg, r.linhas);
          receber(card, por ? estado(card.cfg, por) : estadoOferta(card.cfg), origem);
        });
      }).catch(function (err) {
        if (minha !== leitura.versao) return;
        if (raiz.console && console.warn) console.warn('[NaguirreCombo] não li o carrinho:', err && err.message);
        emOferta(origem);
      });
    }, 300);
  }
  function emOferta(origem) {
    cartoes.forEach(function (card) { receber(card, estadoOferta(card.cfg), origem); });
  }

  function itemInteiro(i) {
    return i && typeof i === 'object' && i.quantity != null && (i.product_id != null || i.variant_id != null || i.id != null);
  }

  function ligar() {
    iniciar();

    document.addEventListener('cart-update', function (ev) {
      var d = ev && ev.detail;
      if (d && Array.isArray(d.items) && d.items.every(itemInteiro)) {
        ultimoEvento = Date.now();
        leitura.versao++;                                   // descarta leitura que ainda esteja a caminho
        clearTimeout(leitura.espera);
        clearTimeout(esperaClique);
        iniciar();
        cartoes.forEach(function (card) {
          var por = contar(card.cfg, d.items);
          receber(card, por ? estado(card.cfg, por) : estadoOferta(card.cfg), 'evento');
        });
      } else {
        var pedido = Date.now();                            // app mandou um carrinho parcial
        setTimeout(function () { if (ultimoEvento < pedido) reler('parcial'); }, ESPERA_PARCIAL);
      }
    });

    // Toque em "Adicionar" (desta página ou dos cards): se nenhum "cart-update" chegar, relê.
    function aoAdicionar(ev) {
      var alvo = ev.target;
      if (ev.type === 'submit') {
        if (!alvo || !alvo.matches || !alvo.matches('form[data-type="add-to-cart-form"]')) return;
      } else if (!alvo || !alvo.closest || !alvo.closest('[data-btn-addtocart], button[name="add"]')) {
        return;
      }
      var marca = ultimoEvento;
      clearTimeout(esperaClique);
      esperaClique = setTimeout(function () { if (ultimoEvento === marca) reler('clique'); }, ESPERA_CLIQUE);
    }
    document.addEventListener('click', aoAdicionar, true);
    document.addEventListener('submit', aoAdicionar, true);

    // Ação dela: toque, tecla ou clique de verdade. "click" entra porque o TalkBack e o VoiceOver ativam
    // com um clique só; eventos criados por script (o tema dispara cliques nas cores ao carregar) não contam.
    ['pointerdown', 'touchstart', 'keydown', 'click'].forEach(function (tipo) {
      document.addEventListener(tipo, function (ev) { if (ev.isTrusted !== false) interagiu = true; }, { capture: true, passive: true });
    });

    // Gaveta: abre por cima da página depois do "Adicionar"; ao fechar, mostra o que estava guardado.
    function aoMudarGaveta() {
      var aberta = gavetaAberta();
      if (aberta === gavetaEstava) return;
      gavetaEstava = aberta;
      clearTimeout(esperaGaveta);
      if (!aberta) esperaGaveta = setTimeout(mostrarGuardados, ESPERA_GAVETA);
    }
    gavetaEstava = gavetaAberta();
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(aoMudarGaveta);
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    // Voltou pela seta do navegador (página restaurada do cache): o carrinho pode ter mudado.
    raiz.addEventListener('pageshow', function (ev) { if (ev.persisted) reler('volta'); });
    // Voltou à aba depois de mais de 3 s: mostra o que estava guardado e relê (no máximo a cada 10 s).
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { escondidaEm = Date.now(); return; }
      mostrarGuardados();
      var agora = Date.now();
      if (escondidaEm && agora - escondidaEm > 3000 && agora - Math.max(leitura.ultima, ultimoEvento) > 10000) reler('volta');
    });

    // Editor do tema: seção recarregada.
    document.addEventListener('shopify:section:load', iniciar);
  }

  raiz.NaguirreCombo = {
    versao: '2026-10-04',
    nucleo: nucleo,
    reler: reler,
    iniciar: iniciar,
    _cartoes: function () { return cartoes; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})(typeof window !== 'undefined' ? window : this);
